/**
 * Section orchestrator
 */

interface SectionRefreshDeps {
    updateOverviewStats: () => void;
    updateOverviewAlerts: () => void;
    renderUpcomingMaintenance: () => void;
    renderRecentDecisions: () => void;
    renderTransactions: () => void;
    updateFinanceSummary: () => void;
    renderBills: () => void;
    renderDuesTable: () => void;
    renderMaintenance: () => void;
    renderTasks: () => void;
    renderDecisions: () => void;
    renderApartments: () => void;
    updateResidentDashboard: () => void;
    renderResidentBills: () => void;
    renderResidentDecisions: () => void;
    renderResidentDocuments: () => void;
    loadResidentProfile: () => void;
    renderNotificationHistory: () => void;
    renderDocuments: () => void;
}

export function refreshSectionOrchestrator(sectionId: string, deps: SectionRefreshDeps): void {
    switch (sectionId) {
        case 'overview':
            deps.updateOverviewStats();
            deps.updateOverviewAlerts();
            deps.renderUpcomingMaintenance();
            deps.renderRecentDecisions();
            break;
        case 'finance':
            deps.renderTransactions();
            deps.updateFinanceSummary();
            break;
        case 'electricity':
            deps.renderBills();
            break;
        case 'dues':
            deps.renderDuesTable();
            break;
        case 'maintenance':
            deps.renderMaintenance();
            break;
        case 'tasks':
            deps.renderTasks();
            break;
        case 'decisions':
            deps.renderDecisions();
            break;
        case 'apartments':
            deps.renderApartments();
            break;
        case 'resident-overview':
            deps.updateResidentDashboard();
            break;
        case 'resident-bills':
            deps.renderResidentBills();
            break;
        case 'resident-decisions':
            deps.renderResidentDecisions();
            break;
        case 'resident-documents':
            deps.renderResidentDocuments();
            break;
        case 'resident-profile':
            deps.loadResidentProfile();
            break;
        case 'notifications':
            deps.renderNotificationHistory();
            break;
        case 'documents':
            deps.renderDocuments();
            break;
    }
}
